import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { configs } from '../configs';
import { WordpressService } from '@streamamg/wordpress-lib';
import { Observable, ReplaySubject } from 'rxjs';
import { WpCommonData, WpFixedPages } from '../types/wordpress/common-data.type';
import { WpCategories, WpCategory } from '../types/wordpress/category.type';
import { WpTeam, WpTeams } from '../types/wordpress/team.type';
import { WpDocumentaries, WpDocumentary } from '../types/wordpress/documentary.type';

@Injectable({
  providedIn: 'root',
})
export class WordpressServiceExtended {


  constructor(
    private wordpressService: WordpressService,
    private httpClient: HttpClient,
  ) {

    // super.init(environment.wordpress.api, `${environment.wordpress.api}${configs.wordpress.commonData}`);
  }

  public getFixedPages(): Observable<WpFixedPages> {

    const items: ReplaySubject<WpFixedPages> = new ReplaySubject(1);

    this.wordpressService.getCommonData().subscribe((value: WpCommonData) => {

      if (value) {

        items.next(value.pages);
        items.complete();
      }
    });

    return items.asObservable();
  }

  public getCategories(): Observable<WpCategory[]> {

    const items: ReplaySubject<WpCategory[]> = new ReplaySubject(1);

    this.wordpressService.getPageData(configs.wordpress.subPaths.categories).subscribe((value: WpCategories) => {

      if (value) {

        items.next(Object.values(value).sort((a, b) => (a.post_title > b.post_title) ? 1 : -1));
        items.complete();
      }
    });

    return items.asObservable();
  }

  public getTeams(): Observable<WpTeam[]> {

    const items: ReplaySubject<WpTeam[]> = new ReplaySubject(1);

    this.wordpressService.getPageData(configs.wordpress.subPaths.teams).subscribe((value: WpTeams) => {

      if (value) {

        items.next(Object.values(value));
        items.complete();
      }
    });

    return items.asObservable();
  }

  public getDocumentaries(): Observable<WpDocumentary[]> {

    const items: ReplaySubject<WpDocumentary[]> = new ReplaySubject(1);

    this.wordpressService.getPageData(configs.wordpress.subPaths.documentaries).subscribe((value: WpDocumentaries) => {

      if (value) {

        items.next(Object.values(value));
        items.complete();
      }
    });

    return items.asObservable();
  }
}
